import type { CatalogOf } from '../types';
import type { en } from './en';

export const ms: CatalogOf<typeof en> = {
  header: {
    brand: 'Doc Assist',
  },
  language: {
    label: 'Bahasa',
  },
  consult: {
    booked: 'Anzu akan bercakap dengan anda dalam {language}.',
  },
  languages: {
    en: 'Bahasa Inggeris',
    id: 'Bahasa Indonesia',
    hi: 'Bahasa Hindi',
    zh: 'Bahasa Mandarin',
  },
  form: {
    title: 'Maklumat Pesakit',
    sessionActive: 'Sesi Aktif',
    name: {
      label: 'Nama Pilihan',
      placeholder: 'Masukkan nama penuh pesakit',
      required: 'Nama Pilihan diperlukan',
    },
    dateOfBirth: {
      label: 'Tarikh Lahir',
      placeholder: 'Pilih tarikh lahir',
      required: 'Tarikh Lahir diperlukan',
      invalid: 'Sila masukkan tarikh lahir yang sah',
    },
    gender: {
      label: 'Jantina Semasa Lahir',
      placeholder: 'Pilih jantina semasa lahir',
      male: 'Lelaki',
      female: 'Perempuan',
      required: 'Jantina Semasa Lahir diperlukan',
    },
    mode: {
      label: 'Mod komunikasi pilihan saya ialah',
      voice: 'Suara',
      text: 'Teks',
      required: 'Mod komunikasi perlu dipilih',
    },
    start: 'Mulakan Sesi Baharu',
  },
  conversation: {
    emptyVoice: 'Perbualan anda akan dipaparkan di sini',
    emptyText: 'Anzu sedang bersedia. Anda boleh mula menaip di bawah.',
    typing: 'Anzu sedang menaip',
    you: 'Anda',
    anzu: 'Anzu',
    placeholder: 'Taip mesej anda...',
    send: 'Hantar',
  },
  session: {
    end: 'Tamatkan Sesi',
    saving: 'Menyimpan Sesi...',
    confirmBody: 'Adakah anda pasti mahu menamatkan sesi ini? Tindakan ini tidak boleh dibatalkan.',
    continue: 'Teruskan Sesi',
  },
  timeout: {
    title: 'Amaran Tamat Masa Sesi',
    inactive: 'Sesi anda tidak aktif selama 60 saat.',
    countdown: 'Sesi anda akan tamat secara automatik dalam {seconds} saat.',
    hint: 'Klik "Teruskan Sesi" untuk meneruskan, atau biarkan sesi tamat secara automatik.',
    endNow: 'Tamatkan Sekarang',
  },
  errors: {
    micPermission: 'Anzu memerlukan mikrofon anda untuk perbualan suara. Benarkan akses mikrofon dalam pelayar anda dan buka pautan ini semula, atau mulakan semula dan pilih mod teks.',
  },
  disclaimer: {
    title: 'Penafian Umum Platform AIGP Health',
    important: 'PENTING: SILA BACA PENAFIAN INI DENGAN TELITI SEBELUM MENGGUNAKAN PLATFORM AIGP HEALTH.',
    lead: 'Dengan menggunakan platform AI AIGP Health "Anzu", pengguna mengakui dan bersetuju dengan perkara berikut:',
    point1: 'Platform ini menggunakan kecerdasan buatan (AI) untuk mengumpulkan maklumat anda.',
    point2: 'Maklumat yang dimasukkan ke dalam sistem AI akan dihantar kepada doktor yang merawat anda pada masa konsultasi anda yang dijadualkan.',
    point3: 'Maklumat tersebut tidak akan diakses, disemak, atau diambil tindakan oleh mana-mana doktor sebelum temu janji anda.',
    point4: 'Platform ini tidak bertujuan untuk digunakan dalam kecemasan perubatan.',
    point5: 'Jika anda mengalami sakit dada, kesukaran bernafas, pendarahan teruk, atau apa-apa keadaan serius atau mengancam nyawa, tamatkan sesi sekarang dan segera hubungi 000.',
    point6: 'Jika keadaan anda bertambah buruk selepas menamatkan sesi pra-konsultasi ini, anda bersetuju untuk mendapatkan rawatan perubatan kecemasan atau menghubungi hospital tempatan anda.',
    point7: 'Dengan terus menggunakan platform ini, anda mengesahkan bahawa ini bukan kecemasan perubatan dan bahawa anda memahami Anzu hanyalah alat pra-konsultasi.',
    point8: 'AIGP Health tidak bertanggungjawab atas akibat yang timbul daripada kelewatan rawatan apabila perhatian kecemasan diperlukan.',
    cancel: 'Batal',
    agree: 'Saya Bersetuju - Mulakan Sesi',
  },
  farewell: {
    preparing: 'Menyediakan ringkasan anda...',
    preparingHint: 'Ia hanya mengambil masa sebentar.',
    thanks: 'Terima kasih kerana menggunakan AIGP Health Doc Assist',
    loggingOut: 'Log keluar...',
  },
};
